import TableChart from "@mui/icons-material/TableChart";

import { makeSvgIcon } from "./svg-icon";

export const GemdTableIcon = makeSvgIcon(
  TableChart,
  (theme) => theme.palette.data.main,
);

export default GemdTableIcon;
